const UXCAM_SDK_ID = "uxcam-web-sdk";

const parseJsonSafely = (jsonString) => {
    if (!jsonString) return null;
    try {
        return JSON.parse(jsonString);
    } catch (e) {
        return null;
    }
};

const collectUxcamProps = (el) => {
    const jsonProps = parseJsonSafely(el.getAttribute("data-uxcam-props"));
    const dataset = el.dataset || {};
    const extraProps = {};

    Object.keys(dataset).forEach((key) => {
        if (!key.startsWith("uxcam")) return;
        if (key === "uxcamEvent" || key === "uxcamProps") return;

        const raw = key.replace(/^uxcam/, "");
        if (!raw) return;

        const camel = raw.charAt(0).toLowerCase() + raw.slice(1);
        const snake = camel.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        extraProps[snake] = dataset[key];
    });

    return { ...jsonProps, ...extraProps };
};

const ensureUxcamInitialized = () => {
    if (window.__uxcam_initialized__) return
    window.__uxcam_initialized__ = true;

    const apiKey = window.gon?.uxcam_api_key;
    if (!apiKey) return;

    window.uxc = window.uxc || {
        __t: [],
        __ak: apiKey,
        __o: {},
        event: function (n, p) { this.__t.push(['event', n, p]); },
        setUserIdentity: function (i) { this.__t.push(['setUserIdentity', i]); },
        setUserProperty: function (k, v) { this.__t.push(['setUserProperty', k, v]); },
        setUserProperties: function (p) { this.__t.push(['setUserProperties', p]); }
    };

    if (document.getElementById(UXCAM_SDK_ID)) return;

    const script = document.createElement('script');
    script.src = 'https://websdk-recording.uxcam.com/index.js';
    script.async = true;
    script.defer = true;
    script.id = UXCAM_SDK_ID;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
};

const uxcamEvent = async (name, props = {}) => {
    let uxc = uxc || window.uxc;
    if (!uxc || typeof uxc.event !== "function") {
        console.warn("[UXCam] not ready", uxc);
        return false;
    } else if (!name) {
        console.warn("[UXCam] no events", name);
        return false;
    } else {
        console.info("[UXCam] Submitted successfully", name);
        return uxc.event(name, props);
    }
};

window.uxcamEventOnce = async function (name, props = {}) {
    const key = `uxcam_event_${name}`;
    if (sessionStorage.getItem(key)) return;
    try {
        const uxc = await waitForUXCam();
        uxc.event(name, props);
        sessionStorage.setItem(key, "1");
        console.info("[UXCam] Submitted successfully:", name);
    } catch (e) {
        console.warn("[UXCam] fn.e skipped:", name, e.message);
    }
};

const waitForUXCam = ({ interval = 300, timeout = 5000 } = {}) => {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        const check = () => {
            const uxc = window.uxc;
            if (uxc && typeof uxc.event === "function") {
                return resolve(uxc);
            }

            if (Date.now() - start >= timeout) {
                return reject(new Error("UXCam not ready"));
            }
            setTimeout(check, interval);
        };
        check();
    });
};

const uxcamSetUserIdentity = (userId) => {
    if (window.uxc && typeof window.uxc.setUserIdentity === "function") {
        window.uxc.setUserIdentity(userId);
    }
};

const uxcamSetUserProperties = (props = {}) => {
    if (window.uxc && typeof window.uxc.setUserProperties === "function") {
        window.uxc.setUserProperties(props);
    }
};

const attachUxcamDelegatedTracking = () => {
    if (window.__uxcam_delegated_tracking__) return;
    window.__uxcam_delegated_tracking__ = true;

    document.addEventListener("click", (e) => {
        const target = e.target;
        if (!target) return;

        const el = target.closest?.("[data-uxcam-event]");
        if (!el) return;

        const name = el.getAttribute("data-uxcam-event");
        if (!name) return;

        const props = collectUxcamProps(el);
        uxcamEvent(name, props);

    })
};

const bootUxcam = () => {
    ensureUxcamInitialized();
    attachUxcamDelegatedTracking();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootUxcam);
} else {
    bootUxcam();
}

document.addEventListener("turbolinks:load", bootUxcam);

export {
    ensureUxcamInitialized,
    uxcamEvent,
    uxcamSetUserIdentity,
    uxcamSetUserProperties,
};

window.ensureUxcamInitialized = ensureUxcamInitialized;
window.uxcamEvent = uxcamEvent;
window.uxcamSetUserIdentity = uxcamSetUserIdentity;
window.uxcamSetUserProperties = uxcamSetUserProperties;
const UXCAM_SDK_ID = "uxcam-web-sdk";

const parseJsonSafely = (jsonString) => {
    if (!jsonString) return null;
    try {
        return JSON.parse(jsonString);
    } catch (e) {
        return null;
    }
};

const collectUxcamProps = (el) => {
    const jsonProps = parseJsonSafely(el.getAttribute("data-uxcam-props"));
    const dataset = el.dataset || {};
    const extraProps = {};

    Object.keys(dataset).forEach((key) => {
        if (!key.startsWith("uxcam")) return;
        if (key === "uxcamEvent" || key === "uxcamProps") return;

        const raw = key.replace(/^uxcam/, "");
        if (!raw) return;

        const camel = raw.charAt(0).toLowerCase() + raw.slice(1);
        const snake = camel.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        extraProps[snake] = dataset[key];
    });

    return { ...jsonProps, ...extraProps };
};

const ensureUxcamInitialized = () => {
    if (window.__uxcam_initialized__) return
    window.__uxcam_initialized__ = true;

    const apiKey = window.gon?.uxcam_api_key;
    if (!apiKey) return;

    window.uxc = window.uxc || {
        __t: [],
        __ak: apiKey,
        __o: {},
        event: function (n, p) { this.__t.push(['event', n, p]); },
        setUserIdentity: function (i) { this.__t.push(['setUserIdentity', i]); },
        setUserProperty: function (k, v) { this.__t.push(['setUserProperty', k, v]); },
        setUserProperties: function (p) { this.__t.push(['setUserProperties', p]); }
    };

    if (document.getElementById(UXCAM_SDK_ID)) return;

    const script = document.createElement('script');
    script.src = 'https://websdk-recording.uxcam.com/index.js';
    script.async = true;
    script.defer = true;
    script.id = UXCAM_SDK_ID;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
};

const uxcamEvent = async (name, props = {}) => {
    let uxc = uxc || window.uxc;
    if (!uxc || typeof uxc.event !== "function") {
        console.warn("[UXCam] not ready", uxc);
        return false;
    } else if (!name) {
        console.warn("[UXCam] no events", name);
        return false;
    } else {
        console.info("[UXCam] Submitted successfully", name);
        return uxc.event(name, props);
    }
};

window.uxcamEventOnce = async function (name, props = {}) {
    const key = `uxcam_event_${name}`;
    if (sessionStorage.getItem(key)) return;
    try {
        const uxc = await waitForUXCam();
        uxc.event(name, props);
        sessionStorage.setItem(key, "1");
        console.info("[UXCam] Submitted successfully:", name);
    } catch (e) {
        console.warn("[UXCam] fn.e skipped:", name, e.message);
    }
};

const waitForUXCam = ({ interval = 300, timeout = 5000 } = {}) => {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        const check = () => {
            const uxc = window.uxc;
            if (uxc && typeof uxc.event === "function") {
                return resolve(uxc);
            }

            if (Date.now() - start >= timeout) {
                return reject(new Error("UXCam not ready"));
            }
            setTimeout(check, interval);
        };
        check();
    });
};

const uxcamSetUserIdentity = (userId) => {
    if (window.uxc && typeof window.uxc.setUserIdentity === "function") {
        window.uxc.setUserIdentity(userId);
    }
};

const uxcamSetUserProperties = (props = {}) => {
    if (window.uxc && typeof window.uxc.setUserProperties === "function") {
        window.uxc.setUserProperties(props);
    }
};

const attachUxcamDelegatedTracking = () => {
    if (window.__uxcam_delegated_tracking__) return;
    window.__uxcam_delegated_tracking__ = true;

    document.addEventListener("click", (e) => {
        const target = e.target;
        if (!target) return;

        const el = target.closest?.("[data-uxcam-event]");
        if (!el) return;

        const name = el.getAttribute("data-uxcam-event");
        if (!name) return;

        const props = collectUxcamProps(el);
        uxcamEvent(name, props);

    })
};

const bootUxcam = () => {
    ensureUxcamInitialized();
    attachUxcamDelegatedTracking();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootUxcam);
} else {
    bootUxcam();
}

document.addEventListener("turbolinks:load", bootUxcam);

export {
    ensureUxcamInitialized,
    uxcamEvent,
    uxcamSetUserIdentity,
    uxcamSetUserProperties,
};

window.ensureUxcamInitialized = ensureUxcamInitialized;
window.uxcamEvent = uxcamEvent;
window.uxcamSetUserIdentity = uxcamSetUserIdentity;
window.uxcamSetUserProperties = uxcamSetUserProperties;
